<template>
  <div>
  <b-container fluid class="page-header py-5 mb-5 text-center">
    <b-container class="py-5">
      <h1 class="display-3 text-white mb-3 animated slideInDown">About Us</h1>

      <!-- Breadcrumb -->
      <b-breadcrumb
        class="animated slideInDown justify-content-center"
        :items="breadcrumbItems"
        aria-label="breadcrumb"
      >
        <template #item="{ item }">
          <span :class="['breadcrumb-item', item.active ? 'active text-white' : 'text-white']">
            <router-link v-if="item.to" :to="item.to" class="text-white">{{ item.text }}</router-link>
            <span v-else>{{ item.text }}</span>
          </span>
        </template>
      </b-breadcrumb>
    </b-container>
  </b-container>
 

   <!-- Include Experience component -->
  <ExperiencePage />

  <!-- Include Experience component -->
   <HappyPage />
  </div>
</template>

<script>

import ExperiencePage from '../components/ExperiencePage.vue';
import HappyPage from '../components/HappyPage.vue';

export default {
  name: "AboutPage",
   components: {
    ExperiencePage, HappyPage  // ✅ register component here
  },
  data() {
    return {
      breadcrumbItems: [
        { text: 'Home', to: '/' },
        { text: 'About',  to: '/aboutpage'}
      ]
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)),
  url('@/assets/carousel_1.jpg') center center no-repeat;
  background-size: cover;
  font-family: 'Poppins', sans-serif;
}
.breadcrumb-item {
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
}
.breadcrumb 
{ background-color: transparent !important; padding: 0; margin: 0; }

.breadcrumb-item .router-link-active,
.breadcrumb-item .router-link-exact-active,
.breadcrumb-item a {
  color: white !important;
  text-decoration: none;
}

h1 
{ 
  font-size: 3rem; /* Bigger size for About Us */ 
  font-family: 'Poppins',  sans-serif; 
  font-weight: bold;
}

</style>
